import Cookies from "js-cookie";
import axios from "axios";
import { getBaseUrl } from "../../utils";

const send_notification = getBaseUrl() + "admin/notification/send";
const puja_list_by_name = getBaseUrl() + "admin/pujaListByName";
const notification_history = getBaseUrl() + "admin/notification_history";

export const sendNotification_api = async (data) => {
  let config = {
    method: "post",
    url: send_notification,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
    data: data,
  };
  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getPujaListByName_api = async () => {
  let config = {
    method: "get",
    url: puja_list_by_name,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
  };
  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getNotificationHistory_api = async (data) => {
  let config = {
    method: "get",
    url:
      notification_history +
      `?page=${data?.page}&limit=${data?.limit}&search=${data?.search}`,
    headers: { Authorization: `Bearer ${Cookies.get("token")}` },
  };
  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};